import _ from "lodash";
import { absolutePath } from "./absolutePath";

export interface ProrationParams {
  new_plan_id: string | number;
  only_ch?: boolean;
  plan_coupon_id?: string | number;
}

export interface FetchPlanParams {
  billing_currency?: string | null;
  id?: string;
  isPriceTestingEnabled?: boolean;
  locale?: string | null;
  plan_type?: string;
  tier?: string;
}

export interface FetchPlansParams {
  billing_currency?: string | null;
  billing_cycle?: string | null;
  isPriceTestingEnabled?: boolean;
  locale?: string | null;
}

export interface FetchEmailHubPlanParams {
  billing_currency?: string | null;
  locale?: string | null;
}

const cleanParams = (params: Record<string, unknown>) =>
  _.omitBy(params, value => _.isNil(value) || value === "");

const experimentedPlanPath = (
  isPriceTestingEnabled: boolean,
  basePath: string,
) =>
  isPriceTestingEnabled ? `communities/experimentation/${basePath}` : basePath;

export const plans = {
  proration: ({ new_plan_id, plan_coupon_id = "", only_ch }: ProrationParams) =>
    absolutePath(
      "plans/prorations",
      cleanParams({ new_plan_id, plan_coupon_id, only_ch }),
    ),

  fetch: ({
    tier,
    id,
    billing_currency,
    locale,
    plan_type,
    isPriceTestingEnabled = false,
  }: FetchPlanParams) => {
    const base = tier ? { tier } : id ? { id } : {};
    const params = cleanParams({
      ...base,
      billing_currency,
      locale,
      plan_type,
    });
    const path = experimentedPlanPath(isPriceTestingEnabled, "plan");

    return absolutePath(path, params);
  },

  fetchPlans: ({
    billing_cycle,
    billing_currency,
    locale,
    isPriceTestingEnabled = false,
  }: FetchPlansParams = {}) => {
    const params = cleanParams({ billing_cycle, billing_currency, locale });
    const path = experimentedPlanPath(isPriceTestingEnabled, "plans");

    return absolutePath(path, params);
  },

  fetchEmailHubPlan: ({
    billing_currency,
    locale,
  }: FetchEmailHubPlanParams) => {
    const params = cleanParams({ billing_currency, locale });

    return absolutePath("email_hub/plans", params);
  },
};
